export enum ProductDesign {
  FROCK = "Frock",
  KAFTAN_TROUSER = "Kaftan shirt with Trouser",
  KAFTAN_DUPATTA = "Kaftan shirt with Dupatta",
  SHIRT_TROUSER = "Shirt with Trouser",
  SHIRT_DUPATTA = "Shirt with Dupatta",
  SHIRT_TROUSER_DUPATTA = "Shirt with Trouser & Dupatta",
  FROCK_TROUSER = "Frock with Trouser",
  FROCK_DUPATTA = "Frock with Dupatta",
  FROCK_TROUSER_DUPATTA = "Frock with Trouser Dupatta",

  MAXI = "Maxi Dress",
  LONG_SHIRT = "Long Shirt",
  SHIRT_PLAZO = "Shirt with Plazo",
  KURTA_TROUSER = "Kurta with Trouser",
  KURTA_DUPATTA = "Kurta with Dupatta",
  SHIRT_CHURIDAR = "Shirt with Churidar",
  CAPE_STYLE = "Cape Style Shirt with Trouser",
  LONG_SHIRT_TROUSER = "Long Shirt with Trouser",
  LONG_SHIRT_TROUSER_DUPATTA = "Long Shirt with Trouser & Dupatta",
}
